import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useTemplatesList() {
  // Use toast
  const toast = useToast();

  const refTemplateListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true, class: "sticky-column" },
    { key: "template_name", class: "sticky-column", label: "模版名稱", sortable: true },
    { key: "logo_image_path", label: "Logo圖片", class: "sticky-column"},
    { key: "actions", label: "操作", class: "sticky-column" },
    // { key: "stamp_image_path", label: "簽名", sortable: true },
    { key: "company_info", label: "公司資訊", sortable: true },
    { key: "bank_info", label: "銀行帳號資訊", sortable: true },
    { key: "address", label: "地址", sortable: true },
    { key: 'website', label: "網址"},
    { key: 'phone', label: "電話"},
    { key: "email", label: "電郵" },
    { key: "fax", label: "傳真" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const templatesList = ref(null);

  // const filter_template_type_id = ref(null);
  // const filter_project_id = ref(null);
  // const filter_customer_id = ref(null);
  // const filter_product_id = ref(null);
  // const filter_quotation_id = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refTemplateListTable.value
      ? refTemplateListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refTemplateListTable.value.refresh();
  };

  watch(
    [
      currentPage, perPage, searchQuery, 
      // filter_template_type_id, filter_project_id, filter_customer_id,
      // filter_product_id, filter_quotation_id
    ],
    () => {
      refetchData();
    }
  );

  const fetchTemplates = (ctx, callback) => {

    store
      .dispatch("template/fetchTemplates", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        // template_type_id: filter_template_type_id.value,
        // quotation_id: filter_quotation_id.value,
        // project_id : filter_project_id.value,
        // customer_id: filter_customer_id.value,
        // product_id: filter_product_id.value
      })
      .then((response) => {
        const { templates, total } = response.data;
        callback(templates);
        totalRow.value = total;
        templatesList.value = templates
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取模版清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  // const templateTypeOptions = ref([]);
  // const quotationOptions = ref([]);
  // const customerOptions = ref([]);
  // const productOptions = ref([]);
  // const workerOptions = ref([]);
  // const projectOptions = ref([])

  // const refetchOption = () => {
  //   store
  //     .dispatch("app/fetchOptionList", {
  //       quotation_types: true,
  //       quotations: true,
  //       customers: true,
  //       products: true,
  //       projects: true,
  //     })
  //     .then((response) => {
  //       templateTypeOptions.value = response.data.quotation_types;
  //       quotationOptions.value = response.data.quotations;
  //       customerOptions.value = response.data.customers;
  //       productOptions.value = response.data.products;
  //       workerOptions.value = response.data.workers;
  //       projectOptions.value = response.data.projects;
  //     });
  // };

  onMounted(() => {
    // refetchOption();
  });

  return {
    fetchTemplates,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    templatesList,
    refTemplateListTable,
    ability,
    refetchData,
    // filter_template_type_id,
    // filter_project_id,
    // filter_customer_id,
    // filter_product_id,
    // filter_quotation_id,
    // templateTypeOptions,
    // quotationOptions,
    // customerOptions,
    // productOptions,
    // workerOptions,
    // projectOptions,
  };
}
